import { HttpCacheClient } from '../http/http-cache-client';
import * as i0 from "@angular/core";
import * as i1 from "../http/http-cache-client";
var ValueLists = /** @class */ (function () {
    function ValueLists(httpClient) {
        this.httpClient = httpClient;
    }
    ValueLists.prototype.get = function (names) {
        return this.httpClient.getWithCache('value-lists/' + names.join(','));
    };
    ValueLists.prototype.getPermissions = function () {
        return this.httpClient.getWithCache('value-lists/permissions');
    };
    ValueLists.ngInjectableDef = i0.defineInjectable({ factory: function ValueLists_Factory() { return new ValueLists(i0.inject(i1.HttpCacheClient)); }, token: ValueLists, providedIn: "root" });
    return ValueLists;
}());
export { ValueLists };
